/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddCommunityChannelMessageReportRequest,
  AddCommunityChannelMessageRequest,
  AddMemberToCommunityChannelRequest,
  CreateCommunityChannelRequest,
  IdResponse,
  ToggleCommunityChannelMessageBookmarkRequest,
  ToggleCommunityChannelMessagePinRequest,
  ToggleCommunityChannelMessageReactionRequest,
  UpdateCommunityChannelMemberRequest,
  UpdateCommunityChannelRequest,
} from '../models/index';

export interface CommunityChannelApiControllerAddCommunityChannelMessageRequest {
    sellerId: string;
    channelId: string;
    AddCommunityChannelMessageRequest: AddCommunityChannelMessageRequest;
}

export interface CommunityChannelApiControllerAddCommunityChannelMessageReportRequest {
    sellerId: string;
    channelId: string;
    messageId: string;
    AddCommunityChannelMessageReportRequest: AddCommunityChannelMessageReportRequest;
}

export interface CommunityChannelApiControllerAddMemberToCommunityChannelRequest {
    sellerId: string;
    channelId: string;
    AddMemberToCommunityChannelRequest: AddMemberToCommunityChannelRequest;
}

export interface CommunityChannelApiControllerCreateCommunityChannelRequest {
    sellerId: string;
    CreateCommunityChannelRequest: CreateCommunityChannelRequest;
}

export interface CommunityChannelApiControllerDeleteCommunityChannelRequest {
    sellerId: string;
    channelId: string;
}

export interface CommunityChannelApiControllerDeleteCommunityChannelMessageRequest {
    sellerId: string;
    channelId: string;
    messageId: string;
}

export interface CommunityChannelApiControllerRemoveMemberFromCommunityChannelRequest {
    sellerId: string;
    channelId: string;
    memberId: string;
}

export interface CommunityChannelApiControllerToggleCommunityChannelMessageBookmarkRequest {
    sellerId: string;
    channelId: string;
    messageId: string;
    ToggleCommunityChannelMessageBookmarkRequest: ToggleCommunityChannelMessageBookmarkRequest;
}

export interface CommunityChannelApiControllerToggleCommunityChannelMessagePinRequest {
    sellerId: string;
    channelId: string;
    messageId: string;
    ToggleCommunityChannelMessagePinRequest: ToggleCommunityChannelMessagePinRequest;
}

export interface CommunityChannelApiControllerToggleCommunityChannelMessageReactionRequest {
    sellerId: string;
    channelId: string;
    messageId: string;
    ToggleCommunityChannelMessageReactionRequest: ToggleCommunityChannelMessageReactionRequest;
}

export interface CommunityChannelApiControllerToggleCommunityChannelMessageSubscriptionRequest {
    sellerId: string;
    channelId: string;
    messageId: string;
    body: object;
}

export interface CommunityChannelApiControllerToggleMemberBlockInCommunityChannelRequest {
    sellerId: string;
    channelId: string;
    memberId: string;
}

export interface CommunityChannelApiControllerUpdateCommunityChannelRequest {
    sellerId: string;
    channelId: string;
    UpdateCommunityChannelRequest: UpdateCommunityChannelRequest;
}

export interface CommunityChannelApiControllerUpdateMemberInCommunityChannelRequest {
    sellerId: string;
    channelId: string;
    memberId: string;
    UpdateCommunityChannelMemberRequest: UpdateCommunityChannelMemberRequest;
}

/**
 * 
 */
export class CommunityChannelApi extends runtime.BaseAPI {

    /**
     */
    async communityChannelApiControllerAddCommunityChannelMessageRaw(requestParameters: CommunityChannelApiControllerAddCommunityChannelMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IdResponse>> {
        if (requestParameters['sellerId'] == null) {
            throw new runtime.RequiredError(
                'sellerId',
                'Required parameter "sellerId" was null or undefined when calling communityChannelApiControllerAddCommunityChannelMessage().'
            );
        }

        if (requestParameters['channelId'] == null) {
            throw new runtime.RequiredError(
                'channelId',
                'Required parameter "channelId" was null or undefined when calling communityChannelApiControllerAddCommunityChannelMessage().'
            );
        }

        if (requestParameters['AddCommunityChannelMessageRequest'] == null) {
            throw new runtime.RequiredError(
                'AddCommunityChannelMessageRequest',
                'Required parameter "AddCommunityChannelMessageRequest" was null or undefined when calling communityChannelApiControllerAddCommunityChannelMessage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/stores/{sellerId}/community-channels/{channelId}/messages`;
        urlPath = urlPath.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters['sellerId'])));
        urlPath = urlPath.replace(`{${"channelId"}}`, encodeURIComponent(String(requestParameters['channelId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['AddCommunityChannelMessageRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async communityChannelApiControllerAddCommunityChannelMessage(requestParameters: CommunityChannelApiControllerAddCommunityChannelMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IdResponse> {
        const response = await this.communityChannelApiControllerAddCommunityChannelMessageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async communityChannelApiControllerAddCommunityChannelMessageReportRaw(requestParameters: CommunityChannelApiControllerAddCommunityChannelMessageReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['sellerId'] == null) {
            throw new runtime.RequiredError(
                'sellerId',
                'Required parameter "sellerId" was null or undefined when calling communityChannelApiControllerAddCommunityChannelMessageReport().'
            );
        }

        if (requestParameters['channelId'] == null) {
            throw new runtime.RequiredError(
                'channelId',
                'Required parameter "channelId" was null or undefined when calling communityChannelApiControllerAddCommunityChannelMessageReport().'
            );
        }

        if (requestParameters['messageId'] == null) {
            throw new runtime.RequiredError(
                'messageId',
                'Required parameter "messageId" was null or undefined when calling communityChannelApiControllerAddCommunityChannelMessageReport().'
            );
        }

        if (requestParameters['AddCommunityChannelMessageReportRequest'] == null) {
            throw new runtime.RequiredError(
                'AddCommunityChannelMessageReportRequest',
                'Required parameter "AddCommunityChannelMessageReportRequest" was null or undefined when calling communityChannelApiControllerAddCommunityChannelMessageReport().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/stores/{sellerId}/community-channels/{channelId}/messages/{messageId}:report`;
        urlPath = urlPath.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters['sellerId'])));
        urlPath = urlPath.replace(`{${"channelId"}}`, encodeURIComponent(String(requestParameters['channelId'])));
        urlPath = urlPath.replace(`{${"messageId"}}`, encodeURIComponent(String(requestParameters['messageId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['AddCommunityChannelMessageReportRequest'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async communityChannelApiControllerAddCommunityChannelMessageReport(requestParameters: CommunityChannelApiControllerAddCommunityChannelMessageReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.communityChannelApiControllerAddCommunityChannelMessageReportRaw(requestParameters, initOverrides);
    }

    /**
     */
    async communityChannelApiControllerAddMemberToCommunityChannelRaw(requestParameters: CommunityChannelApiControllerAddMemberToCommunityChannelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IdResponse>> {
        if (requestParameters['sellerId'] == null) {
            throw new runtime.RequiredError(
                'sellerId',
                'Required parameter "sellerId" was null or undefined when calling communityChannelApiControllerAddMemberToCommunityChannel().'
            );
        }

        if (requestParameters['channelId'] == null) {
            throw new runtime.RequiredError(
                'channelId',
                'Required parameter "channelId" was null or undefined when calling communityChannelApiControllerAddMemberToCommunityChannel().'
            );
        }

        if (requestParameters['AddMemberToCommunityChannelRequest'] == null) {
            throw new runtime.RequiredError(
                'AddMemberToCommunityChannelRequest',
                'Required parameter "AddMemberToCommunityChannelRequest" was null or undefined when calling communityChannelApiControllerAddMemberToCommunityChannel().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/stores/{sellerId}/community-channels/{channelId}/members`;
        urlPath = urlPath.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters['sellerId'])));
        urlPath = urlPath.replace(`{${"channelId"}}`, encodeURIComponent(String(requestParameters['channelId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['AddMemberToCommunityChannelRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async communityChannelApiControllerAddMemberToCommunityChannel(requestParameters: CommunityChannelApiControllerAddMemberToCommunityChannelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IdResponse> {
        const response = await this.communityChannelApiControllerAddMemberToCommunityChannelRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async communityChannelApiControllerCreateCommunityChannelRaw(requestParameters: CommunityChannelApiControllerCreateCommunityChannelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IdResponse>> {
        if (requestParameters['sellerId'] == null) {
            throw new runtime.RequiredError(
                'sellerId',
                'Required parameter "sellerId" was null or undefined when calling communityChannelApiControllerCreateCommunityChannel().'
            );
        }

        if (requestParameters['CreateCommunityChannelRequest'] == null) {
            throw new runtime.RequiredError(
                'CreateCommunityChannelRequest',
                'Required parameter "CreateCommunityChannelRequest" was null or undefined when calling communityChannelApiControllerCreateCommunityChannel().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/stores/{sellerId}/community-channels`;
        urlPath = urlPath.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters['sellerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['CreateCommunityChannelRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async communityChannelApiControllerCreateCommunityChannel(requestParameters: CommunityChannelApiControllerCreateCommunityChannelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IdResponse> {
        const response = await this.communityChannelApiControllerCreateCommunityChannelRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async communityChannelApiControllerDeleteCommunityChannelRaw(requestParameters: CommunityChannelApiControllerDeleteCommunityChannelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['sellerId'] == null) {
            throw new runtime.RequiredError(
                'sellerId',
                'Required parameter "sellerId" was null or undefined when calling communityChannelApiControllerDeleteCommunityChannel().'
            );
        }

        if (requestParameters['channelId'] == null) {
            throw new runtime.RequiredError(
                'channelId',
                'Required parameter "channelId" was null or undefined when calling communityChannelApiControllerDeleteCommunityChannel().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/stores/{sellerId}/community-channels/{channelId}`;
        urlPath = urlPath.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters['sellerId'])));
        urlPath = urlPath.replace(`{${"channelId"}}`, encodeURIComponent(String(requestParameters['channelId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async communityChannelApiControllerDeleteCommunityChannel(requestParameters: CommunityChannelApiControllerDeleteCommunityChannelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.communityChannelApiControllerDeleteCommunityChannelRaw(requestParameters, initOverrides);
    }

    /**
     */
    async communityChannelApiControllerDeleteCommunityChannelMessageRaw(requestParameters: CommunityChannelApiControllerDeleteCommunityChannelMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['sellerId'] == null) {
            throw new runtime.RequiredError(
                'sellerId',
                'Required parameter "sellerId" was null or undefined when calling communityChannelApiControllerDeleteCommunityChannelMessage().'
            );
        }

        if (requestParameters['channelId'] == null) {
            throw new runtime.RequiredError(
                'channelId',
                'Required parameter "channelId" was null or undefined when calling communityChannelApiControllerDeleteCommunityChannelMessage().'
            );
        }

        if (requestParameters['messageId'] == null) {
            throw new runtime.RequiredError(
                'messageId',
                'Required parameter "messageId" was null or undefined when calling communityChannelApiControllerDeleteCommunityChannelMessage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/stores/{sellerId}/community-channels/{channelId}/messages/{messageId}`;
        urlPath = urlPath.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters['sellerId'])));
        urlPath = urlPath.replace(`{${"channelId"}}`, encodeURIComponent(String(requestParameters['channelId'])));
        urlPath = urlPath.replace(`{${"messageId"}}`, encodeURIComponent(String(requestParameters['messageId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async communityChannelApiControllerDeleteCommunityChannelMessage(requestParameters: CommunityChannelApiControllerDeleteCommunityChannelMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.communityChannelApiControllerDeleteCommunityChannelMessageRaw(requestParameters, initOverrides);
    }

    /**
     */
    async communityChannelApiControllerRemoveMemberFromCommunityChannelRaw(requestParameters: CommunityChannelApiControllerRemoveMemberFromCommunityChannelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['sellerId'] == null) {
            throw new runtime.RequiredError(
                'sellerId',
                'Required parameter "sellerId" was null or undefined when calling communityChannelApiControllerRemoveMemberFromCommunityChannel().'
            );
        }

        if (requestParameters['channelId'] == null) {
            throw new runtime.RequiredError(
                'channelId',
                'Required parameter "channelId" was null or undefined when calling communityChannelApiControllerRemoveMemberFromCommunityChannel().'
            );
        }

        if (requestParameters['memberId'] == null) {
            throw new runtime.RequiredError(
                'memberId',
                'Required parameter "memberId" was null or undefined when calling communityChannelApiControllerRemoveMemberFromCommunityChannel().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/stores/{sellerId}/community-channels/{channelId}/members/{memberId}`;
        urlPath = urlPath.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters['sellerId'])));
        urlPath = urlPath.replace(`{${"channelId"}}`, encodeURIComponent(String(requestParameters['channelId'])));
        urlPath = urlPath.replace(`{${"memberId"}}`, encodeURIComponent(String(requestParameters['memberId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async communityChannelApiControllerRemoveMemberFromCommunityChannel(requestParameters: CommunityChannelApiControllerRemoveMemberFromCommunityChannelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.communityChannelApiControllerRemoveMemberFromCommunityChannelRaw(requestParameters, initOverrides);
    }

    /**
     */
    async communityChannelApiControllerToggleCommunityChannelMessageBookmarkRaw(requestParameters: CommunityChannelApiControllerToggleCommunityChannelMessageBookmarkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['sellerId'] == null) {
            throw new runtime.RequiredError(
                'sellerId',
                'Required parameter "sellerId" was null or undefined when calling communityChannelApiControllerToggleCommunityChannelMessageBookmark().'
            );
        }

        if (requestParameters['channelId'] == null) {
            throw new runtime.RequiredError(
                'channelId',
                'Required parameter "channelId" was null or undefined when calling communityChannelApiControllerToggleCommunityChannelMessageBookmark().'
            );
        }

        if (requestParameters['messageId'] == null) {
            throw new runtime.RequiredError(
                'messageId',
                'Required parameter "messageId" was null or undefined when calling communityChannelApiControllerToggleCommunityChannelMessageBookmark().'
            );
        }

        if (requestParameters['ToggleCommunityChannelMessageBookmarkRequest'] == null) {
            throw new runtime.RequiredError(
                'ToggleCommunityChannelMessageBookmarkRequest',
                'Required parameter "ToggleCommunityChannelMessageBookmarkRequest" was null or undefined when calling communityChannelApiControllerToggleCommunityChannelMessageBookmark().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/stores/{sellerId}/community-channels/{channelId}/messages/{messageId}:toggleBookmark`;
        urlPath = urlPath.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters['sellerId'])));
        urlPath = urlPath.replace(`{${"channelId"}}`, encodeURIComponent(String(requestParameters['channelId'])));
        urlPath = urlPath.replace(`{${"messageId"}}`, encodeURIComponent(String(requestParameters['messageId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['ToggleCommunityChannelMessageBookmarkRequest'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async communityChannelApiControllerToggleCommunityChannelMessageBookmark(requestParameters: CommunityChannelApiControllerToggleCommunityChannelMessageBookmarkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.communityChannelApiControllerToggleCommunityChannelMessageBookmarkRaw(requestParameters, initOverrides);
    }

    /**
     */
    async communityChannelApiControllerToggleCommunityChannelMessagePinRaw(requestParameters: CommunityChannelApiControllerToggleCommunityChannelMessagePinRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['sellerId'] == null) {
            throw new runtime.RequiredError(
                'sellerId',
                'Required parameter "sellerId" was null or undefined when calling communityChannelApiControllerToggleCommunityChannelMessagePin().'
            );
        }

        if (requestParameters['channelId'] == null) {
            throw new runtime.RequiredError(
                'channelId',
                'Required parameter "channelId" was null or undefined when calling communityChannelApiControllerToggleCommunityChannelMessagePin().'
            );
        }

        if (requestParameters['messageId'] == null) {
            throw new runtime.RequiredError(
                'messageId',
                'Required parameter "messageId" was null or undefined when calling communityChannelApiControllerToggleCommunityChannelMessagePin().'
            );
        }

        if (requestParameters['ToggleCommunityChannelMessagePinRequest'] == null) {
            throw new runtime.RequiredError(
                'ToggleCommunityChannelMessagePinRequest',
                'Required parameter "ToggleCommunityChannelMessagePinRequest" was null or undefined when calling communityChannelApiControllerToggleCommunityChannelMessagePin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/stores/{sellerId}/community-channels/{channelId}/messages/{messageId}:togglePin`;
        urlPath = urlPath.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters['sellerId'])));
        urlPath = urlPath.replace(`{${"channelId"}}`, encodeURIComponent(String(requestParameters['channelId'])));
        urlPath = urlPath.replace(`{${"messageId"}}`, encodeURIComponent(String(requestParameters['messageId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['ToggleCommunityChannelMessagePinRequest'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async communityChannelApiControllerToggleCommunityChannelMessagePin(requestParameters: CommunityChannelApiControllerToggleCommunityChannelMessagePinRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.communityChannelApiControllerToggleCommunityChannelMessagePinRaw(requestParameters, initOverrides);
    }

    /**
     */
    async communityChannelApiControllerToggleCommunityChannelMessageReactionRaw(requestParameters: CommunityChannelApiControllerToggleCommunityChannelMessageReactionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['sellerId'] == null) {
            throw new runtime.RequiredError(
                'sellerId',
                'Required parameter "sellerId" was null or undefined when calling communityChannelApiControllerToggleCommunityChannelMessageReaction().'
            );
        }

        if (requestParameters['channelId'] == null) {
            throw new runtime.RequiredError(
                'channelId',
                'Required parameter "channelId" was null or undefined when calling communityChannelApiControllerToggleCommunityChannelMessageReaction().'
            );
        }

        if (requestParameters['messageId'] == null) {
            throw new runtime.RequiredError(
                'messageId',
                'Required parameter "messageId" was null or undefined when calling communityChannelApiControllerToggleCommunityChannelMessageReaction().'
            );
        }

        if (requestParameters['ToggleCommunityChannelMessageReactionRequest'] == null) {
            throw new runtime.RequiredError(
                'ToggleCommunityChannelMessageReactionRequest',
                'Required parameter "ToggleCommunityChannelMessageReactionRequest" was null or undefined when calling communityChannelApiControllerToggleCommunityChannelMessageReaction().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/stores/{sellerId}/community-channels/{channelId}/messages/{messageId}:toggleReaction`;
        urlPath = urlPath.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters['sellerId'])));
        urlPath = urlPath.replace(`{${"channelId"}}`, encodeURIComponent(String(requestParameters['channelId'])));
        urlPath = urlPath.replace(`{${"messageId"}}`, encodeURIComponent(String(requestParameters['messageId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['ToggleCommunityChannelMessageReactionRequest'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async communityChannelApiControllerToggleCommunityChannelMessageReaction(requestParameters: CommunityChannelApiControllerToggleCommunityChannelMessageReactionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.communityChannelApiControllerToggleCommunityChannelMessageReactionRaw(requestParameters, initOverrides);
    }

    /**
     */
    async communityChannelApiControllerToggleCommunityChannelMessageSubscriptionRaw(requestParameters: CommunityChannelApiControllerToggleCommunityChannelMessageSubscriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['sellerId'] == null) {
            throw new runtime.RequiredError(
                'sellerId',
                'Required parameter "sellerId" was null or undefined when calling communityChannelApiControllerToggleCommunityChannelMessageSubscription().'
            );
        }

        if (requestParameters['channelId'] == null) {
            throw new runtime.RequiredError(
                'channelId',
                'Required parameter "channelId" was null or undefined when calling communityChannelApiControllerToggleCommunityChannelMessageSubscription().'
            );
        }

        if (requestParameters['messageId'] == null) {
            throw new runtime.RequiredError(
                'messageId',
                'Required parameter "messageId" was null or undefined when calling communityChannelApiControllerToggleCommunityChannelMessageSubscription().'
            );
        }

        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling communityChannelApiControllerToggleCommunityChannelMessageSubscription().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/stores/{sellerId}/community-channels/{channelId}/messages/{messageId}:toggleSubscription`;
        urlPath = urlPath.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters['sellerId'])));
        urlPath = urlPath.replace(`{${"channelId"}}`, encodeURIComponent(String(requestParameters['channelId'])));
        urlPath = urlPath.replace(`{${"messageId"}}`, encodeURIComponent(String(requestParameters['messageId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async communityChannelApiControllerToggleCommunityChannelMessageSubscription(requestParameters: CommunityChannelApiControllerToggleCommunityChannelMessageSubscriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.communityChannelApiControllerToggleCommunityChannelMessageSubscriptionRaw(requestParameters, initOverrides);
    }

    /**
     */
    async communityChannelApiControllerToggleMemberBlockInCommunityChannelRaw(requestParameters: CommunityChannelApiControllerToggleMemberBlockInCommunityChannelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['sellerId'] == null) {
            throw new runtime.RequiredError(
                'sellerId',
                'Required parameter "sellerId" was null or undefined when calling communityChannelApiControllerToggleMemberBlockInCommunityChannel().'
            );
        }

        if (requestParameters['channelId'] == null) {
            throw new runtime.RequiredError(
                'channelId',
                'Required parameter "channelId" was null or undefined when calling communityChannelApiControllerToggleMemberBlockInCommunityChannel().'
            );
        }

        if (requestParameters['memberId'] == null) {
            throw new runtime.RequiredError(
                'memberId',
                'Required parameter "memberId" was null or undefined when calling communityChannelApiControllerToggleMemberBlockInCommunityChannel().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/stores/{sellerId}/community-channels/{channelId}/members/{memberId}:toggleBlock`;
        urlPath = urlPath.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters['sellerId'])));
        urlPath = urlPath.replace(`{${"channelId"}}`, encodeURIComponent(String(requestParameters['channelId'])));
        urlPath = urlPath.replace(`{${"memberId"}}`, encodeURIComponent(String(requestParameters['memberId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async communityChannelApiControllerToggleMemberBlockInCommunityChannel(requestParameters: CommunityChannelApiControllerToggleMemberBlockInCommunityChannelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.communityChannelApiControllerToggleMemberBlockInCommunityChannelRaw(requestParameters, initOverrides);
    }

    /**
     */
    async communityChannelApiControllerUpdateCommunityChannelRaw(requestParameters: CommunityChannelApiControllerUpdateCommunityChannelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['sellerId'] == null) {
            throw new runtime.RequiredError(
                'sellerId',
                'Required parameter "sellerId" was null or undefined when calling communityChannelApiControllerUpdateCommunityChannel().'
            );
        }

        if (requestParameters['channelId'] == null) {
            throw new runtime.RequiredError(
                'channelId',
                'Required parameter "channelId" was null or undefined when calling communityChannelApiControllerUpdateCommunityChannel().'
            );
        }

        if (requestParameters['UpdateCommunityChannelRequest'] == null) {
            throw new runtime.RequiredError(
                'UpdateCommunityChannelRequest',
                'Required parameter "UpdateCommunityChannelRequest" was null or undefined when calling communityChannelApiControllerUpdateCommunityChannel().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/stores/{sellerId}/community-channels/{channelId}`;
        urlPath = urlPath.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters['sellerId'])));
        urlPath = urlPath.replace(`{${"channelId"}}`, encodeURIComponent(String(requestParameters['channelId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['UpdateCommunityChannelRequest'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async communityChannelApiControllerUpdateCommunityChannel(requestParameters: CommunityChannelApiControllerUpdateCommunityChannelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.communityChannelApiControllerUpdateCommunityChannelRaw(requestParameters, initOverrides);
    }

    /**
     */
    async communityChannelApiControllerUpdateMemberInCommunityChannelRaw(requestParameters: CommunityChannelApiControllerUpdateMemberInCommunityChannelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['sellerId'] == null) {
            throw new runtime.RequiredError(
                'sellerId',
                'Required parameter "sellerId" was null or undefined when calling communityChannelApiControllerUpdateMemberInCommunityChannel().'
            );
        }

        if (requestParameters['channelId'] == null) {
            throw new runtime.RequiredError(
                'channelId',
                'Required parameter "channelId" was null or undefined when calling communityChannelApiControllerUpdateMemberInCommunityChannel().'
            );
        }

        if (requestParameters['memberId'] == null) {
            throw new runtime.RequiredError(
                'memberId',
                'Required parameter "memberId" was null or undefined when calling communityChannelApiControllerUpdateMemberInCommunityChannel().'
            );
        }

        if (requestParameters['UpdateCommunityChannelMemberRequest'] == null) {
            throw new runtime.RequiredError(
                'UpdateCommunityChannelMemberRequest',
                'Required parameter "UpdateCommunityChannelMemberRequest" was null or undefined when calling communityChannelApiControllerUpdateMemberInCommunityChannel().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/stores/{sellerId}/community-channels/{channelId}/members/{memberId}`;
        urlPath = urlPath.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters['sellerId'])));
        urlPath = urlPath.replace(`{${"channelId"}}`, encodeURIComponent(String(requestParameters['channelId'])));
        urlPath = urlPath.replace(`{${"memberId"}}`, encodeURIComponent(String(requestParameters['memberId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['UpdateCommunityChannelMemberRequest'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async communityChannelApiControllerUpdateMemberInCommunityChannel(requestParameters: CommunityChannelApiControllerUpdateMemberInCommunityChannelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.communityChannelApiControllerUpdateMemberInCommunityChannelRaw(requestParameters, initOverrides);
    }

}
